import * as React from "react";
import { useEffect, useLayoutEffect, useState } from "react";
import i18n from "i18n";
import { WBSStore } from "modules/WBS/WBSStore";
import {
  Grid,
  Chip,
  Checkbox,
  Button,
  Typography,
  withStyles,
  Tooltip,
} from "@material-ui/core";
import { Column, Table, SortDirection } from "react-virtualized";
import DetailsModal from "modules/WBS/components/layouts/DetailsModal";
import { ProfileService } from "modules/profile/ProfileService";
import { sortString } from "utils/StringUtils";
import { formatNumber } from "utils/MathUtils";

const styles = (theme) => ({
  checkDescription: {
    width: "100%",
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "610px",
    margin: "0 auto",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  button: {
    margin: "0px 19px",
  },
  root: {
    color: "#616161",
    "&$checked": {
      color: "#9AAF00",
    },
  },
  checked: { color: "#9AAF00" },
  headerClass: {
    // padding: "5px 15px",
    padding: "5px 0px",
    textAlign: "center" as any,
    "&:nth-child(1)": { paddingLeft: "15px" },
    "&:nth-child(3)": {
      // display: "flex",
      flexDirection: "row" as any,
      // alignItems: "center",
    },
    "&:nth-child(4)": { textAlign: "left" as any },
    "&:nth-last-child(2)": { textAlign: "right" as any },
    "&:nth-last-child(3)": { textAlign: "right" as any },
  },
  rowClass: {
    borderBottom: "solid 1px #E0E0E0",
    padding: "15px 0px",
    // borderTop: "solid 1px #E0E0E0",
  },
  padding15: { padding: "0px 15px" },
  statusAdjust: {
    backgroundColor: "#FABE24",
    padding: "0px",
    height: "20px",
    fontSize: "13px",
    fontWeight: 400,
    width: "80px",
    color: "#424242",
    textTransform: "capitalize" as any,
  },
  statusNotExist: {
    backgroundColor: "#D73912",
    padding: "0px",
    height: "20px",
    fontSize: "13px",
    fontWeight: 400,
    width: "80px",
    color: "#fff",
    textTransform: "capitalize" as any,
  },
  datailsLink: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "16px",
    color: "#137CBD",
    textDecoration: "underline",
    cursor: "pointer",
    padding: "4px 0px",
  },
  lightTooltip: {
    backgroundColor: theme.palette.common.black,
    color: "rgba(255, 255, 255, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  descriptionText: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "16px",
    color: "#616161",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as any,
    overflow: "hidden",
    padding: "3px",
  },
  tableNotThead: {
    "& th": {
      padding: "5px 15px",
      textAlign: "center" as any,
    },
  },
  tableNotTbody: {
    "& td": {
      padding: "5px 15px",
      textAlign: "center" as any,
      borderBottom: "solid 1px #E0E0E0",
      borderTop: "solid 1px #E0E0E0",
    },
  },
});

const UpdateCompositionsTabe2 = (props) => {
  const { classes, compositionId } = props;
  const status = {
    ajuste: "ajuste",
    inalterado: "inalterado",
    inexistente: "inexistente",
  };
  type tabeRow = {
    contentId: string;
    selected: boolean;
    status: string;
    code: string;
    description: string;
    unit: string;
    unitCost: string;
    newCost: string;
    alternativeCodeComposition?: string;
  };

  const list: tabeRow[] = WBSStore.compositionUpdateList;
  const [showModal, setShowModal] = useState(false);
  const [updateDescritions, setUpdateDescriptions] = useState(true);
  const [useList, setUseList] = useState<tabeRow[]>([]);
  const [primaryChecked, setPrimaryChecked] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [selectedLine, setSelectedLine] = useState(false);
  const [selectedAllLines, setSelectedAllLines] = useState(false);
  const [rowDataShow, setRowDataShow] = useState({});
  const sortDirection = SortDirection.ASC;
  useEffect(() => {
    setUseList(list);
    ProfileService.checkUserChangeDescription().then((res) => {
      setUpdateDescriptions(res);
    });
  }, [list]);
  useLayoutEffect(() => {
    let itemSelected = useList.findIndex((item) => item.selected);
    let everySelected: boolean;
    let auxList = useList.filter((item) => item.status === status.ajuste);
    if (itemSelected >= 0) {
      everySelected = auxList.every((item) => item.selected == true);
      setSelectedLine(true);
      setSelectedAllLines(everySelected);
    } else {
      everySelected = auxList.every((item) => item.selected == true);
      setSelectedLine(false);
      setSelectedAllLines(everySelected);
    }
  }, [useList]);
  const resort = (element) => {
    setSortBy(element.sortBy);
    let auxList = list.sort((a, b) => {
      if (element.sortBy == "code") {
        return a[element.sortBy] - b[element.sortBy];
      } else {
        return sortString(a[element.sortBy], b[element.sortBy]);
      }
    });
    setUseList(auxList);
    setPrimaryChecked(false);
  };

  const changeCheckBox = (event, item) => {
    let auxList = [...useList];
    if (useList) {
      auxList[item.rowIndex].selected = event.target.checked;
      setUseList(auxList);
    }
  };

  const changeUpdateDescritions = async () => {
    setUpdateDescriptions(!updateDescritions);
  };

  const checkeBox = (item) => {
    if (item.rowData.status == status.ajuste) {
      return (
        <Checkbox
          key={item.index}
          style={{ padding: "0px" }}
          checked={useList[item.rowIndex].selected}
          onChange={(event) => changeCheckBox(event, item)}
          value={useList[item.rowIndex].selected}
          classes={{
            root: classes.root,
            checked: classes.checked,
          }}
        />
      );
    } else {
      return false;
    }
  };
  const renderDescription = (item) => {
    return (
      <Tooltip
        title={item.rowData.description}
        classes={{ tooltip: classes.lightTooltip }}
      >
        <Typography variant="body1" className={classes.descriptionText}>
          {item.rowData.description}
        </Typography>
      </Tooltip>
    );
  };
  const renderStatus = (item) => {
    return (
      <Chip
        label={item.rowData.status == status.ajuste ? "Ajuste" : "não existe"}
        className={
          item.rowData.status == status.ajuste
            ? classes.statusAdjust
            : classes.statusNotExist
        }
      />
    );
  };
  const renderDetails = (item) => {
    return (
      <Typography
        variant="body1"
        className={classes.datailsLink}
        onClick={() => openModal(item)}
      >
        {i18n.updateCompositions.details}
      </Typography>
    );
  };
  const headerRender = () => {
    return (
      <Checkbox
        style={{ padding: "0px" }}
        checked={
          primaryChecked ? primaryChecked : selectedAllLines ? true : false
        }
        onChange={(event) => changePrimaryChecked(event)}
        value={
          primaryChecked ? primaryChecked : selectedAllLines ? true : false
        }
        indeterminate={selectedLine ? (selectedAllLines ? false : true) : false}
        classes={{
          root: classes.root,
          checked: classes.checked,
        }}
      />
    );
  };
  const changePrimaryChecked = (event) => {
    let auxList = useList.map((item, index) => {
      if (item.status == status.ajuste) {
        item.selected = event.target.checked ? true : false;
      }
      return item;
    });
    setUseList(auxList);
    setPrimaryChecked(!primaryChecked);
  };

  const openModal = (item) => {
    let rowData = item.rowData;
    setRowDataShow(rowData);
    setShowModal(true);
  };

  const cancel = () => {
    WBSStore.replaceComposition = false;
    WBSStore.resetCompositionUpdateData();
  };

  const sendCompositionsCodes = async () => {
    const filteredList = useList
      .filter((item) => item.selected)
      .map((item) => item.code);

    WBSStore.loadingTaskUpload = true;
    WBSStore.updateCompositionsWithRateLibrary(
      compositionId,
      filteredList,
      updateDescritions
    );

    await ProfileService.updateChangeDescription(updateDescritions);
    cancel();
  };

  if (useList && useList.length > 0) {
    return (
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="flex-start"
        style={{ position: "relative", height: "100%" }}
      >
        <Grid item style={{ position: "relative", height: "100%" }}>
          <Table
            width={window.innerWidth - 290}
            height={540}
            headerHeight={60}
            rowHeight={55}
            rowCount={useList.length}
            rowGetter={({ index }) => useList[index]}
            rowStyle={{ display: "flex" }}
            sort={(element) => resort(element)}
            sortBy={sortBy}
            // sortDirection={sortDirection}
            rowClassName={classes.rowClass}
            headerClassName={classes.headerClass}
            style={{ borderBottom: "1px solid #E0E0E0" }}
          >
            <Column
              width={40}
              label=""
              dataKey="selected"
              disableSort={true}
              headerRenderer={() => headerRender()}
              cellRenderer={(index) => checkeBox(index)}
              className={classes.padding15}
              style={{ textAlign: "center" }}
            />
            <Column
              width={105}
              label={i18n.updateCompositions.status}
              dataKey="status"
              defaultSortDirection={sortDirection == "DESC" ? "ASC" : "DESC"}
              cellRenderer={(index) => renderStatus(index)}
              // className={classes.padding15}
              style={{ textAlign: "center" }}
            />
            <Column
              width={90}
              label={i18n.updateCompositions.code}
              dataKey="code"
              defaultSortDirection={sortDirection}
              // className={classes.padding15}
              style={{ textAlign: "center" }}
            />
            <Column
              width={window.innerWidth - 1000}
              label={i18n.updateCompositions.description}
              dataKey="description"
              defaultSortDirection={sortDirection}
              cellRenderer={(index) => renderDescription(index)}
              // className={classes.padding15}
              style={{ textAlign: "left" }}
            />
            <Column
              width={90}
              label={i18n.updateCompositions.unity}
              dataKey="unit"
              disableSort={true}
              // className={classes.padding15}
              style={{ textAlign: "center" }}
            />
            <Column
              width={130}
              label={i18n.updateCompositions.unitCost}
              dataKey="unitCost"
              disableSort={true}
              cellRenderer={(index) => formatNumber(index.rowData.unitCost)}
              // className={classes.padding15}
              style={{ textAlign: "right" }}
            />
            <Column
              width={135}
              label={i18n.updateCompositions.newCost}
              dataKey="newCost"
              disableSort={true}
              cellRenderer={(index) => formatNumber(index.rowData.newCost)}
              // className={classes.padding15}
              style={{ textAlign: "right" }}
            />
            <Column
              width={100}
              label=""
              dataKey="actions"
              disableSort={true}
              cellRenderer={(index) => renderDetails(index)}
              // className={classes.padding15}
              style={{ paddingLeft: "15px" }}
            />
          </Table>
        </Grid>

        <div
          style={{
            position: "absolute",
            width: "100%",
            bottom: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <Checkbox
              style={{ padding: "4px" }}
              checked={updateDescritions}
              onChange={changeUpdateDescritions}
              classes={{
                root: classes.root,
                checked: classes.checked,
              }}
            />

            <p> {i18n.updateCompositions.changeDescription}</p>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={cancel}
            >
              {i18n.cancel}
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={sendCompositionsCodes}
              disabled={!selectedLine}
            >
              {i18n.continue}
            </Button>
          </div>
        </div>
        <DetailsModal
          showModal={showModal}
          setShowModal={setShowModal}
          rowDataShow={rowDataShow}
        />
      </Grid>
    );
  } else {
    return (
      <>
        <table style={{ width: "100%" }}>
          <thead>
            <tr className={classes.tableNotThead}>
              <th></th>
              <th>{i18n.updateCompositions.status}</th>
              <th>{i18n.updateCompositions.code}</th>
              <th>{i18n.updateCompositions.description}</th>
              <th>{i18n.updateCompositions.unity}</th>
              <th>{i18n.updateCompositions.unitCost}</th>
              <th>{i18n.updateCompositions.newCost}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr className={classes.tableNotTbody}>
              <td colSpan={8}>Não há itens para atualizar</td>
            </tr>
          </tbody>
        </table>
        <div
          style={{
            position: "absolute",
            width: "100%",
            bottom: "50px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={cancel}
          >
            {i18n.cancel}
          </Button>
        </div>
      </>
    );
  }
};

export default withStyles(styles)(UpdateCompositionsTabe2);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/UpdateCompositionsTabe2.tsx